import React, { useState } from 'react';
import styled from 'styled-components';
import Logo from 'assets/images/Logo blue.png';
import { words } from './translations';

const OpenEndedQuestion = ({ saveResponse, setScreen, language }) => {
  const [response, setResponse] = useState('');

  const handleChange = (event) => {
    setResponse(event.target.value);
    const responseObj = {
      response: event.target.value,
      type: 'open_ended'
    };
    saveResponse(responseObj);
  };

  const handleNext = () => {
    if (response.trim()) {
      setScreen();
    }
  };

  const getQuestionText = () => {
    switch(language) {
      case 'FR':
        return "Décrivez votre expérience globale au sein de votre organisation. Qu'est-ce qui fonctionne bien et quels sont les défis que vous rencontrez?";
      case 'ES':
        return "Describa su experiencia general dentro de su organización. ¿Qué está funcionando bien y qué desafíos está enfrentando?";
      default:
        return "What's one aspect of managing employee feedback / survey data that drives you nuts?";
    }
  };

  const getPlaceholderText = () => {
    switch(language) {
      case 'FR':
        return "Partagez vos pensées ici...";
      case 'ES':
        return "Comparta sus pensamientos aquí...";
      default:
        return "Share your thoughts here...";
    }
  };

  const getNextButtonText = () => {
    switch(language) {
      case 'FR':
        return "Suivant";
      case 'ES':
        return "Siguiente";
      default:
        return "Next";
    }
  };

  return (
    <Container>
      <TitleContainer>
        <Title>
          <IMG src={Logo} />
        </Title>
        <Subtitle>
          {language === 'EN' ? 'Feedback Survey' : 
           language === 'FR' ? 'Enquête de feedback' : 
           'Encuesta de retroalimentación'}
        </Subtitle>
      </TitleContainer>

      <ContentSection>
        <QuestionText>{getQuestionText()}</QuestionText>
        
        <StyledTextarea
          value={response}
          onChange={handleChange}
          placeholder={getPlaceholderText()}
        />

        <ButtonArea>
          <Button 
            onClick={handleNext} 
            disabled={!response.trim()}
          >
            {getNextButtonText()}
          </Button>
        </ButtonArea>
      </ContentSection>
    </Container>
  );
};

export default OpenEndedQuestion;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 600px;
  width: 100%;
  font-family: "Raleway", sans-serif;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  width: 100%;
`;

const Title = styled.div`
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  color: #2D70E2;
`;

const IMG = styled.img`
  width: 120px;
`;

const Subtitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #6B7280;
  margin-top: 5px;
`;

const ContentSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const QuestionText = styled.div`
  color: #2a3039;
  font-family: "Raleway";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
`;

const StyledTextarea = styled.textarea`
  display: block;
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #2a3039;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  resize: none;
  font-family: "Raleway", sans-serif;
  height: 150px;

  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #2d70e2;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(45, 112, 226, 0.25);
  }
`;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 20px;
`;

const Button = styled.button`
  color: white;
  font-size: 16px;
  font-weight: 400;
  border: none;
  border-radius: 5px;
  padding: 10px 35px;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 40px;
  background-color: #2D70E2;
  
  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    background-color: #ccc !important;
    cursor: not-allowed;
  }
`; 